import { createFileRoute } from "@tanstack/react-router";
import { GrantsPageContent } from "@/components/grants/grants-page";
import { GRANTS_META, GRANTS_PATH } from "@/content/grants";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/grants")({
  head: () => ({
    ...pageSeo({
      path: GRANTS_PATH,
      title: GRANTS_META.title,
      description: GRANTS_META.description,
    }),
  }),
  component: GrantsPageContent,
});
